import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { FilterPanel } from '@gsa/afp-component-library';
import { useFederalStandards } from '../../fvs-provider';

const {
  FilterPanelField,
  FilterPanelFilterShape,
} = FilterPanel;

const VehicleGroupFilterItem = ({ filter }) => {
  const [options, setOptions] = useState([{ label: 'Select vehicle group', value: '' }]);
  const prevParentValueRef = useRef(null);
  const { clearOneFilter, setFilters, getFilterFromState } = FilterPanel.useFilterPanel();
  const {
    vehicleClassificationOptions,
  } = useFederalStandards();

  const fedStandardCodeFilter = getFilterFromState('fedStandardCode');

  useEffect(() => {
    // Clear this filter when parent value changes
    if (prevParentValueRef.current !== null && prevParentValueRef.current !== fedStandardCodeFilter.value) {
      clearOneFilter(filter);
    }
    prevParentValueRef.current = fedStandardCodeFilter.value;

    if (!fedStandardCodeFilter.value || !vehicleClassificationOptions?.vehicleGroup) {
      setOptions([{ label: 'Select vehicle group', value: '' }]);
      return;
    }

    // Filter vehicle groups based on selected federal standard code
    const filteredGroups = vehicleClassificationOptions.vehicleGroup
      .filter((vGroup) => vGroup.parent === fedStandardCodeFilter.value)
      .map((vGroup) => ({
        label: vGroup.label,
        value: vGroup.value,
      }));

    const optionsWithDefault = [{ label: 'Select vehicle group', value: '' }, ...filteredGroups];
    setOptions(optionsWithDefault);
    setFilters({
      type: 'updateOptions',
      filter: {
        ...filter,
        options: optionsWithDefault,
      },
    });
  }, [fedStandardCodeFilter.value, vehicleClassificationOptions]);

  return (
    <div className="margin-top-3">
      <label htmlFor={filter.key} className="usa-label">
        {filter.title}
      </label>
      <FilterPanelField
        key={[filter.key]}
        filter={{
          ...filter,
          type: 'select',
          options,
        }}
      />
    </div>
  );
};

VehicleGroupFilterItem.propTypes = {
  filter: PropTypes.shape(FilterPanelFilterShape).isRequired,
};

export default VehicleGroupFilterItem;
